import BaseController from "./base_controller"

export default class extends BaseController {
  static outlets = ["design-system--modal-component"]

  handleClick(event) {
    this.designSystemModalComponentOutlet.open()
  }
}
